import { produce } from 'immer';

export function caseProduce<S, P>(
  callback: (draftState: S, payload: P) => void
) {
  return (state: S, payload: P) =>
    produce(state, (draftState: S) => callback(draftState, payload));
}
